const labels = {
    en_US: { blackGold: 'Black & Gold', mexicoEmerald: 'Mexican Emerald', graphiteMint: 'Graphite Mint' },
    es_MX: { blackGold: 'Negro y oro', mexicoEmerald: 'México esmeralda', graphiteMint: 'Grafito menta' },
    pt_BR: { blackGold: 'Preto e dourado', mexicoEmerald: 'México esmeralda', graphiteMint: 'Grafite menta' },
    ru_RU: { blackGold: 'Чёрное золото', mexicoEmerald: 'Мексиканский изумруд', graphiteMint: 'Графит и мята' },
    zh_CN: { blackGold: '黑金典藏', mexicoEmerald: '墨西哥翡翠金', graphiteMint: '现代石墨' }
}

export function themeLabel(name, locale) {
    return (labels[locale] || labels.en_US)[name] || name
}
